<template>
  <div class="app">
    <div class="tab3_content">
      <!-- 左图 -->
      <div class="tab3_content_left ">
        <img src="../assets/2moble.png" class="tab3_moble1">

      </div>

      <!-- 右字 -->
      <div class="tab3_content_right">
        <p class="introduce">
          护眼天使是一款专注于预防和控制近视发生发展的视觉健康服务软件。拥有一键式护眼降低屏幕伤害，检测用眼时间防止视疲劳，眼健康自测了解眼睛功能好坏，以及免费视觉功能训练提高眼睛功能等功能，可以帮助用户更好的保护眼睛，拥有健康的视觉。</p>
        <img src="../assets/bc3.png" class="bc3">

        <div id="contact">
          <div id="contact_left">
            联系我们<br />
            感谢您的关注和支持，如有任何体验问题，可以通过以下方式和我们联系<br />
            光朗(海南)生物科技有限责任公司<br />
            地址：海南省海口市龙华区金贸街道滨海大道117号海南滨海国际金融中心13层A1303单元<br />
            邮箱：huyantianshi8@163.com<br />
            公众号：huyants<br />
            真诚倾听您的意见与建议！比心！<br />
          </div>
          <div id="contact_right">
            <img src="../assets/gzh.jpg">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about"
}

</script>

<style scoped>
page {
  width: 100vw;
  font-size: 12px;
  overflow: hidden;
}
.app {
  height: 600px;
}
.tab3_content {
  width: 50%;
  margin: 0 auto;
  position: relative;
  top: 100px;
  display: flex;
}

.tab3_content_left {
  /*width: 25%;*/
  z-index: 100;
}

.tab3_content_right {
  margin-left: 5%;
  margin-top: 10px;
}

.tab3_moble1 {
  width: 15vw;
  /*height:19vw ;*/
  z-index: 150;
  /*object-fit:contain;*/
}

.bc3 {
  width: 200%;
  position: absolute;
  left: -50%;
  margin-top: 20px;
  z-index: 0;
  min-height: 190px;
  overflow: hidden;
  height: 300px;
}

.introduce {
  text-indent: 2em;
  line-height: 30px;
  font-size: 15px;
  margin-top: 0px;
}

#contact {
  padding-top: 30px;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 14px;
  /*height: 200px;*/
  color: #fff;
  z-index: 10;
  height: 300px;

  min-height: 190px;
}

#contact_left {
  width: 75%;
  z-index: 10;
  line-height: 30px;
}

#contact_right {
  width: 25%;

  z-index: 10;
}

#contact_right img {
  margin-left: 10%;
  width: 80%;
}

@media (max-width: 1050px) {
  .app {
    height: 80vh;
  }
  .tab3_content {
    width: 95%;
    top: 50px;
  }

  .tab3_content_right {
    margin-left: 5%;
  }

  .bc3 {
    left: -5%;
    width: 108%;
    position: absolute;
    margin-top: 20px;
    z-index: 0;
    min-height: 190px;
    height: 300px;
  }

  .tab3_moble1 {
    height: 200px;
    width: 120px;
  }

  .introduce {
    height: 200px;
    width: calc(90vw - 120px);
  }

  #contact {
    width: 95vw;
    position: absolute;
    left: 2.5vw;
  }

  #contact_right img {
    max-height: 160px;
    max-width: 160px;
  }
}
</style>